import axios from 'axios'
import qs from 'qs';


const API_PREFIX = "/api/sector"
const API_PREFIX_STOCK = "/api/stock"

export const apiIndiceList = () => {
    return axios.get(`${API_PREFIX}/public/list`)
}

export const apiIndicePerf = () => {
    return axios.get(`${API_PREFIX}/public/perf`)
}

export const apiIndicesNav = async ({ stockName, from, to, period = null }) => {
    let url = `${API_PREFIX_STOCK}/tv/trade?symbol=${stockName}&resolution=D&from=${from}&to=${to}`
    if (period) url = `${url}&period=${period}`
    return await axios.get(url)
        .then(response => {
            return response
        })
        .catch(error => {
            throw error
        })
}

export const apiIndiceQuote = async (params) => {
    return await axios.get(`${API_PREFIX_STOCK}/public/quote/${params}`)
}